import React, {useState, useEffect, useReducer} from 'react';
import {useSelector} from 'react-redux';
import {labels} from '../../util/utils';
import AddUser from '../Pages/CreateProjectClassic/AddNewGroup/AddUser';
import StyledGroupSelect from '../Common/SelectDropdown/StyledGroupSelect';
import {accessGroupsSelector} from '../ManageTeams/teamUserSelector';
import styled from 'styled-components';

const AddMember = (props) => {
	const [userList, setUserList] = useState([{}]);
	const projectAccessGroups = useSelector((store) => store.projectTeam.accessGroups);
	const [groupsOptions, setGroupsOptions] = useState([{}]);
	const [defaultGroup,setDefaultGroup] = useState([]);

	useEffect(() => {
		if (projectAccessGroups && projectAccessGroups.length > 0) {
			getGroupsOptions();			
		}
	}, [projectAccessGroups]);

	const getGroupsOptions = () => {
		// Sort groups
		const sortedGrops = accessGroupsSelector(projectAccessGroups, {
			projectId: props.projectId,
			isUserProjectOwner: props.isUserProjectOwner,
			loggedInUserGui: props.loggedInUserGui,
			isOversightAdmin: props.isOversightAdmin
		});

		// Get groups based on users permission
		let groups = [];
		sortedGrops.map((group) => {
			if (group.isBuiltIn && (props.isUserProjectOwner || isUserGroupAdministrator(group) || isOversightAdmin)) {
				groups.push({id: group.accessGroupId, label: group.groupName, value: group.accessGroupId});
				setDefaultGroup([{id: group.accessGroupId, label: group.groupName, value: group.accessGroupId}]);
				props.setSelectedGroups([{id: group.accessGroupId, label: group.groupName, value: group.accessGroupId}]);
			}
		});

		setGroupsOptions(groups);
	};

	useEffect(() => {
		if (props.userData && props.userData.userId) {
			var users = [];
			users.push(props.userData);
			setUserList(users);
		}
	}, [props.userData]);

	const isUserGroupAdministrator = (group) => {
		return group.users.some((x) => x.userId == props.loggedInUserGui && x.roles?.some((a) => a === 'admin'));
	};

	const handlerOnMultiSelectItemChange = (option) => {
		props.setSelectedGroups(option);
	};

	return (
		<StyledAddMemberModalBody className="add-member-modal-body customScrollbar">
			<p className='add-member-instruction-text'>{props.isEdit ? labels.editMemberHeaderText : props.isAdminAddMember ? labels.addProjectOwnerInstrText : labels.addMemberHeaderText}</p>
			{!props.isAdminAddMember && <h3>{labels.teamMemberInformation}</h3>}
			{!props.isAdminAddMember && <p>{labels.teamMemberNote}</p>}
			<ul className="add-member-name">
				{userList.map((el) => {
					return (
						<li>
							<AddUser
								key={el.userId}
								id={el.userId}
								className={"add-user-wrap"} 
								isNewAdd={el.isNewAdd}
								userError={props.showUserError}
								isDuplicateUser = {props.isDuplicateUser}
								duplicateUserMessage = {props.duplicateUserMessage}
								clearData={props.clearData}
								isDisabled={props.isEdit}
								hideClearIcon={props.isEdit || !props.canClearSelectedValue}
								canClearSelectedValue={props.canClearSelectedValue}
								hideRemoveIcon={true}
								setSelectedMember={props.setSelectedMember}
								userLookupType= {props.userLookupType}
								isNameEditable = {props.isNameEditable}
							/>
						</li>
					);
				})}
			</ul>
			{!props.isAdminAddMember &&<h3>{labels.placeholderAccess}</h3>}
			{!props.isAdminAddMember &&<p>{labels.selectGroupNote}</p>}
			<StyledGroupSelect
				id="addmember-multi"
				defaultValue={defaultGroup}
				value={defaultGroup}
				optionsList={groupsOptions}
				formLabel={labels.placeholderAccess}
				isClearable
				isMulti
				closeMenuOnSelect={false}
				onChange={handlerOnMultiSelectItemChange}
				noOptionsMessage={() => labels.noResultsFound}
				clearAllValuesLabel={labels.clearHoverText}
				customClearIcon
				className="add-member-select"
				required
				showErrorMessage={props.showGroupError}
				errorMessage={labels.required}
			/>
		</StyledAddMemberModalBody>
	);
};

export default AddMember;

const StyledAddMemberModalBody = styled.section`
	padding: 1.5rem 2rem;
	height: 100%;
	p {
		font-size: 1.4rem;
	}
	h3 {
		font-size: 1.6rem;
		margin-top: 1rem;
	}

	.add-member-name {
		li {
			.react-select__input {
				input {
					width: 92% !important;
				}
			}
		}
	}

	.add-member-instruction-text{
		margin:0;
		line-height: 2rem;
		width: 100%;
		padding-top: 0.5rem;
		padding-bottom: 2rem;
	}

	.add-user-wrap {
		margin: 0;
		.search-box-wrapper {
			margin-left: 0;
			padding-bottom: 0;
			max-height: none;
			width: 40%;
			.userfield-row {
				display: flex;
				flex-direction: column;
			}

			.enterdetail-description {
				bottom: 0;
				margin-top: 0.5rem;
				margin-left: 1rem;
			}
		}

		.user-selectbox{
			.clearall{
				margin-top: 0 !important;
			}
		}

		.group-input-textbox {
			width: 25%;
		}
		.motif-input{
			height: 5rem !important;
		}
		
	}
	.add-member-select {
		margin-top: 1rem;
		line-height: 2rem;
		color: ${(props) => props.theme.color[`red600`]};
		width: 69%;
		.react-select__control {
			.react-select__multi-value {
				align-items: center;
			}
		}

		label{
			font-weight:lighter !important;
		}

		.option-label {
			font-size: 1.2rem;
		}

		&.floating-label {
			label {
				top: 0.5rem;
			}
		}

		label {
			left: 1rem;
			top: 2rem;
		}
		.show {
			font-size: 1.3rem;
			margin-left: 1rem;

			color: ${(props) => props.theme.color[`red600`]};
			svg {
				width: 2rem;
				height: 2rem;
				fill: ${(props) => props.theme.color[`red600`]};
			}
		}

		.react-select__menu-list {
			min-height: 3.5rem;
		}
	}
`;
